import { render, staticRenderFns } from "./NationalPatentCountryShowHistoryListForm.vue?vue&type=template&id=2bbf3612&"
import script from "./NationalPatentCountryShowHistoryListForm.vue?vue&type=script&lang=js&"
export * from "./NationalPatentCountryShowHistoryListForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentCountryShowHistoryListForm.vue?vue&type=style&index=0&id=2bbf3612&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports